<div class="analytics-dashboard">
    <!-- Period Selector -->
    <div class="period-bar">
        <div class="period-buttons">
            <button *ngFor="let p of periods"
                    class="period-button"
                    [class.active]="selectedPeriod === p.value"
                    (click)="onPeriodChange(p.value)">
                {{ p.labelKey | translate }}
            </button>
        </div>

        <div class="custom-dates" *ngIf="showCustomDates">
            <label class="date-label">{{ 'meter.analytics.custom_from' | translate }}</label>
            <input type="date" [(ngModel)]="customFrom" (change)="onCustomDateChange()" class="date-input">
            <label class="date-label">{{ 'meter.analytics.custom_to' | translate }}</label>
            <input type="date" [(ngModel)]="customTo" (change)="onCustomDateChange()" class="date-input">
        </div>

        <mat-form-field class="filter-select" appearance="outline">
            <mat-label>{{ 'meter.analytics.filter_node_type' | translate }}</mat-label>
            <mat-select multiple [value]="selectedNodeTypes" (selectionChange)="onNodeTypeChange($event.value)">
                <mat-option *ngFor="let type of nodeTypeOptions" [value]="type">
                    {{ type }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="filter-select" appearance="outline">
            <mat-label>{{ 'meter.analytics.filter_alert_type' | translate }}</mat-label>
            <mat-select multiple [value]="selectedAlertTypes" (selectionChange)="onAlertTypeChange($event.value)">
                <mat-option *ngFor="let type of alertTypeOptions" [value]="type">
                    {{ type }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <label class="compare-toggle">
            <input type="checkbox" [checked]="comparePrevious" (change)="onCompareToggle()">
            {{ 'meter.analytics.compare_previous' | translate }}
        </label>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{ 'meter.analytics.loading' | translate }}</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
        <mat-icon>error_outline</mat-icon>
        <p>{{ 'meter.analytics.error_message' | translate }}</p>
        <button class="retry-button" (click)="retry()">{{ 'meter.analytics.error_retry' | translate }}</button>
    </div>

    <!-- Dashboard Content -->
    <div *ngIf="!loading && !error && snapshot" class="dashboard-content">
        <app-meter-kpi-cards
            [snapshot]="snapshot"
            [comparePrevious]="comparePrevious">
        </app-meter-kpi-cards>

        <!-- Row 1: Full-width — Top Consumers -->
        <div class="charts-row-full">
            <app-meter-top-consumers
                [data]="distribution?.topConsumers || []">
            </app-meter-top-consumers>
        </div>

        <!-- Row 2: Two-column — Status + Alert Type -->
        <div class="charts-row-2col">
            <app-meter-status-chart
                [data]="distribution?.metersByStatus || []">
            </app-meter-status-chart>

            <app-meter-alert-type-chart
                [data]="distribution?.alertsByType || []">
            </app-meter-alert-type-chart>
        </div>

        <!-- Row 3: Two-column — Consumption Trend + Alert Trend -->
        <div class="charts-row-2col">
            <app-meter-consumption-trend
                [data]="trends?.consumption || null"
                [comparePrevious]="comparePrevious">
            </app-meter-consumption-trend>

            <app-meter-alert-trend
                [data]="trends?.alertVolume || null"
                [comparePrevious]="comparePrevious">
            </app-meter-alert-trend>
        </div>

        <!-- Row 4: Full-width — Heatmap -->
        <div class="charts-row-full">
            <app-meter-heatmap
                [points]="geo?.points || []">
            </app-meter-heatmap>
        </div>
    </div>
</div>
